'use client'

import { useState } from 'react'
import Head from 'next/head'
import { FaChevronDown } from 'react-icons/fa'

interface FAQItem {
  question: string
  answer: string
}

interface FAQProps {
  faqs?: FAQItem[]
}

export default function FAQ({ faqs = [] }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  if (faqs.length === 0) {
    return null
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map(faq => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer
      }
    }))
  };

  return (
    <>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      </Head>
      <section className="py-12 md:py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-900">
              Häufig gestellte Fragen
            </h2>
            <p className="text-lg text-gray-600">
              Finden Sie schnell Antworten auf Ihre Fragen rund um Autoverwertung und KFZ-Ankauf.
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#0066CC] transition-colors duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 sm:py-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors duration-300"
                >
                  <h3 className="text-left font-semibold text-gray-900 sm:text-lg">
                    {faq.question}
                  </h3>
                  <FaChevronDown
                    className={`text-[#0066CC] flex-shrink-0 ml-4 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>

                {openIndex === index && (
                  <div className="px-6 py-4 sm:py-5 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contact CTA
          <div className="mt-12 p-6 sm:p-8 bg-blue-50 rounded-lg border border-[#0066CC] text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">
              Ihre Frage ist nicht beantwortet?
            </h3>
            <p className="text-gray-600 mb-4">
              Kontaktieren Sie uns direkt! Unser Team antwortet gerne auf weitere Fragen.
            </p>
            <a
              href="#contact-form"
              className="inline-block bg-[#0066CC] hover:bg-[#004BA6] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300"
            >
              Jetzt kontaktieren
            </a>
          </div> */}
        </div>
      </div>
    </section>
    </>
  )
}